import { Exclude } from "class-transformer";
import type { EntityValidationRules } from "../services/validationService";
import { enumValue } from "../utils/enumerable";
import Enum from "./enum";

export default class LicensePlate {
  constructor(licensePlate?: string, countryId?: string) {
    if (licensePlate) {
      this.licensePlate = licensePlate;
    }

    if (countryId) {
      this.countryId = countryId;
    }
  }

  licensePlate: string;
  countryId: string;

  @Exclude()
  @enumValue("countries", "countryId")
  country?: Enum;
}

export const LicensePlateValidationRules: EntityValidationRules<LicensePlate> = {
  licensePlate: {
    required: true,
    isLicensePlate: true,
  },
  countryId: {
    required: true,
  },
};
